import React, { Fragment, Component } from 'react'
import {
    Row, Col,Button, Label,Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"
import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import UpdateBloc from '../Blocs/UpdateBloc'

class SyaratJabatanComponent extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailSyarat: {},
            detailPelatihan: [
                {
                    pelatihan_id: 1,
                    pelatihan_penjenjangan: '',
                    pelatihan_teknik: '',
                }
            ],
            detailPengalaman: [
                {
                    pengalaman_id: 1,
                    pengalaman_jabatan: '',
                    pengalaman_lama: '',
                }
            ],
            detailUpaya: [
                {
                    upaya_id: 1,
                    upaya_jenis: '',
                    upaya_frekuensi: '',
                }
            ],
            detailInterest: [
                {
                    interest_id: 1,
                    interest_name: '',
                }
            ],
            dataForm: {},
            isLoading: 0,
        }
    }

    addPelatihan = () => {
        let count = this.state.detailPelatihan.length;
        this.setState({
            detailPelatihan: [
                ...this.state.detailPelatihan,
                {
                    pelatihan_penjenjangan: '',
                    pelatihan_teknik: '',
                    pelatihan_id : count == 0 ? (count+1) : this.state.detailPelatihan.slice(-1)[0].pelatihan_id + 1
                }
            ]
        })

        // console.log(this.state.detailTanggungjawab)
    }
    addUpaya = () => {
        let count = this.state.detailUpaya.length;
        this.setState({
            detailUpaya: [
                ...this.state.detailUpaya,
                {
                    upaya_jenis: '',
                    upaya_frekuensi: '',
                    upaya_id : count == 0 ? (count+1) : this.state.detailUpaya.slice(-1)[0].upaya_id + 1
                }
            ]
        })

        // console.log(this.state.detailTanggungjawab)
    }
    addInterest = () => {
        let count = this.state.detailInterest.length;
        this.setState({
            detailInterest: [
                ...this.state.detailInterest,
                {
                    interest_name: '',
                    interest_id : count == 0 ? (count+1) : this.state.detailInterest.slice(-1)[0].interest_id + 1
                }
            ]
        })

        // console.log(this.state.detailTanggungjawab)
    }
    
    delPelatihan = (data) => {
        let count = this.state.detailPelatihan.length-1;
        this.setState({
            detailPelatihan: [
                ...this.state.detailPelatihan.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }
    delUpaya = (data) => {
        let count = this.state.detailUpaya.length-1;
        this.setState({
            detailUpaya: [
                ...this.state.detailUpaya.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }
    delInterest = (data) => {
        let count = this.state.detailInterest.length-1;
        this.setState({
            detailInterest: [
                ...this.state.detailInterest.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatPelatihan = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["pelatihan_id"] = data.requisite_training_id;
          newObj["pelatihan_penjenjangan"] = data.requisite_training_name;
          newObj["pelatihan_teknik"] = data.requisite_training_technique;
          return newObj;
        });
    }
    reformatPengalaman = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["pengalaman_id"] = data.requisite_experience_id;
          newObj["pengalaman_jabatan"] = data.requisite_experience_nama;
          newObj["pengalaman_lama"] = data.requisite_experience_durasi;
          return newObj;
        });
    }
    reformatUpaya = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["upaya_id"] = data.requisite_training_id;
          newObj["upaya_jenis"] = data.requisite_training_name;
          newObj["upaya_frekuensi"] = data.requisite_training_frequency;
          return newObj;
        });
    }
    reformatInterest = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["interest_id"] = data.requisite_interest_id;
          newObj["interest_name"] = data.requisite_interest_name;
          return newObj;
        });
    }
    
    // -------------handle OnChange Syarat--------------------------------------,
    handleChangeInputPpenjenjangan = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailPelatihan];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.pelatihan_penjenjangan = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailPelatihan : items});
    }
    handleChangeInputPteknik = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailPelatihan];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.pelatihan_teknik = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailPelatihan : items});
    }
    handleChangeInputSpangkat = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailSyarat];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.syarat_pangkat = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailSyarat : items});
    }
    handleChangeInputSpendidikan = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailSyarat];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.syarat_pendidikan = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailSyarat : items});
    }
    handleChangeInputSpenjenjangan = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailSyarat];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.syarat_penjenjangan = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailSyarat : items});
    }
    handleChangeInputSteknik = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailSyarat];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.syarat_teknik = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailSyarat : items});
    }
//==========Handle OnChange Upaya=============
handleChangeInputUjenis = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailUpaya];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.upaya_jenis = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailUpaya : items});
    }
    handleChangeInputUfrekuensi = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailUpaya];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.upaya_frekuensi = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailUpaya : items});
    }
    handleChangeInputInterest = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailInterest];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.interest_name = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailInterest : items});
    }

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    submitSyaratJabatan = async () => {
        await this.updateBloc.fetchUpdateSyaratJabatan(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitSyaratJabatan()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDetailSyaratJabatan = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchRequisite(query)
    }
    loadPelatihan = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchTraining(query)
    }
    loadDetailPengalaman = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchExperience(query)
    }
    // loadDetailUpaya = async () => {
    //     const query = {
    //         uuid: this.props.uuid
    //     }

    //     await this.updateBloc.fetchTraining(query)
    // }
    loadInterest = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchInterest(query)
    }

    handlerOnSubmitSyarat = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                position_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    componentDidMount() {
        this.loadDetailSyaratJabatan()
        this.loadDetailPengalaman()
        this.loadPelatihan()
        this.loadInterest()
        // console.log(this.state.detailTanggungjawab)
        
        this.updateBloc.detailPossesionRequisiteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log('syarat jabatan')
                        if (response != null) {
                            console.log(response)
                            this.setState({ detailSyarat: response })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailTrainingChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        if (response.length > 0) {
                            this.setState({ detailPelatihan: this.reformatPelatihan(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailPengalamanChannel.subscribe((result) => {
            console.log('Pengalaman', result)
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        if (response.length > 0) {
                            this.setState({ detailPengalaman: this.reformatPengalaman(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailUpayaChannel.subscribe((result) => {
            // console.log('Upaya', result)
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        if (response.length > 0) {
                            this.setState({ detailUpaya: this.reformatUpaya(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailInterestChannel.subscribe((result) => {
            // console.log('Upaya', result)
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        if (response.length > 0) {
                            this.setState({ detailInterest: this.reformatInterest(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        this.updateBloc.updaterequisiteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })


    }

    componentWillUnmount() {
        this.updateBloc.positionInfoChannel?.unsubscribe()
        this.updateBloc.detailTanggungjawabChannel?.unsubscribe()
    }

    render() {
        
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitSyarat(e, values)}
                >
                    <Col md="12">
                            <div className="row" style={{padding:'10px'}}>
                                <div className="col-md-5">
                                    <b>Syarat Jabatan</b>
                                    <p>Setiap yang bertanda (<span className="text-danger">*</span>) Wajib Diisi</p>
                                </div>
                            </div>
                            <hr/>
                        </Col>
                    <Row className="mb-12">
                        <div>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Pangkat Golongan <span className="text-danger">*</span>
                                </label>
                                <Col md="9">
                                    <AvField
                                        name="syarat_pangkat"
                                        placeholder="Pangkat Golongan..."
                                        type="text"
                                        errorMessage="Masukkan Pangkat Golongan"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        value={this.state.detailSyarat.requisite_pangkat}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Jenis Pendidikan <span className="text-danger">*</span>
                                </label>
                                <Col md="9">
                                    <AvField
                                        name="syarat_pendidikan"
                                        placeholder="Jenis Pendidikan..."
                                        type="text"
                                        errorMessage="Masukkan Jenis Pendidikan"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        value={this.state.detailSyarat.requisite_pendidikan}
                                    />
                                </Col>
                            </Row>
                        </div>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Kursus/Pelatihan{/*  <span className="text-danger">*</span> */}
                                </label>
                                <Col md="9">
                                   
                                </Col>
                            </Row>
                    {this.state.detailPelatihan.map((data, index) => {
                        return (
                        <div>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Penjenjangan <span className="text-danger">*</span>
                                </label>
                                <Col md="9">
                                    <AvField
                                        name={`syarat_penjenjangan[${index}]`}
                                        placeholder="Penjenjangan..."
                                        type="text"
                                        errorMessage="Masukkan Penjenjangan"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        onChange={(e) => {
                                                    this.handleChangeInputPpenjenjangan(e, index)
                                                }}
                                        value={data.pelatihan_penjenjangan}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Teknik <span className="text-danger">*</span>
                                </label>
                                <Col md="9">
                                    <AvField
                                        name={`syarat_teknik[${index}]`}
                                        placeholder="Teknik..."
                                        type="text"
                                        errorMessage="Masukkan Teknik"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        onChange={(e) => {
                                                    this.handleChangeInputPteknik(e, index)
                                                }}
                                        value={data.pelatihan_teknik}
                                    />
                                </Col>
                                
                                <Col>
                                {
                                    index == 0 ?
                                    <Button className="btn-block waves-effect waves-light mb-1 btn btn-dark"
                                        color="success" 
                                        type="button"   
                                        disabled><i className="uil-trash-alt"></i>
                                    </Button>
                                    :
                                    <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                        color="danger" 
                                        type="button"
                                        onClick={() => {
                                            this.delPelatihan(data)
                                        }}
                                        ><i className="uil-trash-alt"></i>
                                    </Button>
                                }
                                </Col>
                            </Row>
                            <hr />
                        </div>
                            )    
                        })
                    }
                    <div>
                        <Row className="mb-3">
                            <label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            
                            </label>
                            <Col md="9">
                                <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                    color="success" 
                                    type="button"
                                    onClick={this.addPelatihan}
                                    ><i className="uil-plus-circle"></i>Tambah
                                </Button>
                            </Col>
                            <hr />
                        </Row>
                    {this.state.detailPengalaman.map((data, index) => {
                        return (
                        <div>
                        <Row className="mb-3">
                            <label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            Pengalaman Kerja
                            </label>
                            <Col md="9">
                                
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            Jabatan <span className="text-danger">*</span>
                            </label>
                            <Col md="9">
                                <AvField
                                    name="pengalaman_jabatan"
                                    placeholder="Jabatan..."
                                    type="text"
                                    errorMessage="Masukkan Pengalaman Jabatan"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    // onChange={(e) => {
                                    //             this.handleChangeInputSpangkat(e, 1)
                                    //         }}
                                    value={data.pengalaman_jabatan}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                                <label
                                    htmlFor="fielCode"
                                    className="col-md-2 col-form-label"
                                >
                                Lama <span className="text-danger">*</span>
                                </label>
                                <Col md="9">
                                    <AvField
                                        name="pengalaman_lama"
                                        placeholder="Lama..."
                                        type="text"
                                        errorMessage="Masukkan Lama Pekerjaan"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        // onChange={(e) => {
                                        //             this.handleChangeInputSpangkat(e, 2)
                                        //         }}
                                        value={data.pengalaman_lama}
                                    />
                                </Col>
                            </Row>
                            </div>
                            )    
                        })
                    }
                    <hr />
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Kondisi Fisik <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                            <AvField
                                name="syarat_fisik"
                                placeholder="Kondisi Fisik..."
                                type="text"
                                errorMessage="Masukkan Kondisi Fisik"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                value={this.state.detailSyarat.requisite_kondisi_fisik}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Jenis Kelamin <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                            <AvField
                                name="syarat_jk"
                                placeholder="Jenis Kelamin..."
                                type="text"
                                errorMessage="Masukkan Jenis Kelamin"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                value={this.state.detailSyarat.requisite_jenis_kelamin}
                            />
                        </Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Bakat <span className="text-danger">*</span>
                        </label>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        G(Intelegensia) <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                            <AvField
                                name="syarat_intelegensia"
                                placeholder="G(Intelegensia)..."
                                type="text"
                                errorMessage="Masukkan G(Intelegensia)"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                value={this.state.detailSyarat.requisite_bakat_intelegensia}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        V(Verbal) <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                            <AvField
                                name="syarat_verbal"
                                placeholder="V(Verbal)..."
                                type="text"
                                errorMessage="Masukkan V(Verbal)"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                value={this.state.detailSyarat.requisite_bakat_verbal}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        P(Pencerapan Bentuk) <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                            <AvField
                                name="syarat_penyerapan"
                                placeholder="P(Pencerapan Bentuk)..."
                                type="text"
                                errorMessage="Masukkan P(Pencerapan Bentuk)"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                value={this.state.detailSyarat.requisite_bakat_penyerapan_bentuk}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Q(Ketelitian) <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                            <AvField
                                name="syarat_ketelitian"
                                placeholder="Q(Ketelitian)..."
                                type="text"
                                errorMessage="Masukkan Q(Ketelitian)"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                value={this.state.detailSyarat.requisite_bakat_ketelitian}
                            />
                        </Col>
                    </Row>
                </div>
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        Minat
                        </label>
                        <Col md="9">
                            
                        </Col>
                    </Row>
                {
                    this.state.detailInterest.map((data, index) => {
                        return (
                    <div>
                        <Row className="mb-3">
                            <label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            {/* Jenis Upaya <span className="text-danger">*</span> */}
                            </label>
                            <Col md="9">
                                <AvField
                                    name={`interest_name[${index}]`}
                                    placeholder="Minat..."
                                    type="text"
                                    errorMessage="Masukkan Minat"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    onChange={(e) => {
                                                this.handleChangeInputInterest(e, index)
                                            }}
                                    value={data.interest_name}
                                />
                            </Col>
                        
                            <Col>
                            {
                                index == 0 ?
                                <Button className="btn-block waves-effect waves-light mb-1 btn btn-dark"
                                    color="success" 
                                    type="button"   
                                    disabled><i className="uil-trash-alt"></i>
                                </Button>
                                :
                                <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                    color="danger" 
                                    type="button"
                                    onClick={() => {
                                        this.delInterest(data)
                                    }}
                                    ><i className="uil-trash-alt"></i>
                                </Button>
                            }
                            </Col>
                        </Row>
                    </div>
                    )    
                })
            }
                    <Row className="mb-3">
                        <label
                            htmlFor="fielCode"
                            className="col-md-2 col-form-label"
                        >
                        
                        </label>
                        <Col md="9">
                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                color="success" 
                                type="button"
                                onClick={this.addInterest}
                                ><i className="uil-plus-circle"></i>Tambah
                            </Button>
                        </Col>
                        <hr />
                    </Row>
                        
                        <AvField
                            name="position_uuid"
                            type="hidden"
                            value={this.props.uuid}
                            // validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        
                    </Row>
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/syarat_jabatan.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            <Button color="success" type="submit">
                                <i className="uil-arrow-up-right"></i> Simpan Data
                            </Button>
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    null// <Redirect to='/master/syarat_jabatan.html'/>
                : null }
            </Fragment>
        )
    }


}

export default SyaratJabatanComponent
